import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";
import styles from "components/common/button.scss";
import whiteLoadingImageUrl from "loading-white.svg";
import greyLoadingImageUrl from "loading-grey.svg";

export const Button = ({ children, danger, disabled, onClick, link, loading, primary, type }) => {
  const buttonClassNames = getClassNames(danger, disabled, link, primary);
  return (
    <button
      className={ buttonClassNames }
      disabled={ disabled }
      onClick={ onClick }
      tabIndex="-1"
      type={ type }
    >
      <span className={ loading ? styles.invisible : "" }>{ children }</span>
      { !loading ? null : loadingContent(primary, danger, disabled) }
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string
  ]).isRequired,
  danger: PropTypes.bool,
  disabled: PropTypes.bool,
  link: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  primary: PropTypes.bool,
  type: PropTypes.oneOf(["button", "submit"])
};

Button.defaultProps = {
  danger: false,
  disabled: false,
  link: false,
  loading: false,
  onClick: () => {},
  primary: false,
  type: "button"
};

export const ToggleButton = ({
  children,
  danger,
  disabled,
  isOpen,
  onOpenClick,
  onCloseClick,
  link,
  loading,
  primary,
  type
}) => {
  const buttonClassNames = getClassNames(danger, disabled, link, primary);
  return (
    <button
      className={ buttonClassNames }
      disabled={ disabled }
      onClick={ isOpen ? onCloseClick : onOpenClick }
      type={ type }
    >
      <span className={ loading ? styles.invisible : "" }>{children}</span>
      {!loading ? null : loadingContent(primary, danger, disabled)}
    </button>
  );
};

ToggleButton.propTypes = Button.propTypes;
ToggleButton.defaultProps = Button.defaultProps;

const getClassNames = (danger, disabled, link, primary) => {
  const bindedClassnames = classnames.bind(styles);
  const buttonClassNames = bindedClassnames({
    "button--danger-link": link && danger,
    "button--danger": danger && !disabled,
    "button--primary": primary && !disabled,
    "button--link": link,
    button: true
  });
  return buttonClassNames;
};

const loadingContent = (primary, danger, disabled) => (
  <span className={ styles["loading-container"] }>
    <img alt="Loading" src={ ((primary || danger) && !disabled) ? whiteLoadingImageUrl : greyLoadingImageUrl } />
  </span>
);



// WEBPACK FOOTER //
// ./src/js/components/common/button.jsx